import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonPrivate } from '../../button/button.esm.js';

var _excluded = ["className", "to", "role", "target", "height", "rel", "fontSize", "justifyContent", "emPaddingY", "emPaddingX", "replace"];
var Anchor = /*#__PURE__*/React.forwardRef(function Anchor(props, ref) {
  var className = props.className,
    to = props.to,
    _props$role = props.role,
    role = _props$role === void 0 ? 'link' : _props$role,
    _props$target = props.target,
    target = _props$target === void 0 ? '_self' : _props$target,
    _props$height = props.height,
    height = _props$height === void 0 ? 'unset' : _props$height,
    rel = props.rel,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'inherit' : _props$fontSize,
    justifyContent = props.justifyContent,
    emPaddingY = props.emPaddingY,
    emPaddingX = props.emPaddingX,
    replace = props.replace,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ButtonPrivate, _extends({
    ref: ref,
    __themeKey: "anchors",
    as: to ? Link : 'a',
    className: classNames({
      'csg-tui-anchor': true,
      'is-disabled': rest.disabled // don't deconstruct this props
    }, className)
    //@ts-ignore
    ,
    to: to
    //@ts-ignore
    ,
    replace: to ? replace : undefined,
    role: role,
    target: target,
    rel: target === '_blank' ? 'noopener' : rel,
    fontSize: fontSize,
    height: height,
    emPaddingY: emPaddingY ? emPaddingY : undefined,
    emPaddingX: emPaddingX ? emPaddingX : undefined,
    justifyContent: justifyContent ? justifyContent : 'normal'
  }, rest));
});

export default Anchor;
//# sourceMappingURL=anchor.esm.js.map
